import React from 'react'
import { Layout } from 'antd'
/** @jsxImportSource @emotion/react */
import { jsx } from '@emotion/react'
import { Outlet } from 'react-router-dom'
import Nav from './Nav'

const { Content } = Layout

type AppContainerProps = {
  key?: string
  isSider?: boolean
  anchor?: boolean
  sidebar?: React.ReactNode
}

const AppContainer = ({ isSider, key, sidebar, anchor }: AppContainerProps) => (
  <Layout className="layout" key={key}>
    <Nav />
    <Content style={{ padding: '20px 50px', minHeight: '100vh' }}>
      <div style={{ margin: 'auto', maxWidth: '1750px' }}>
        {/* Replace children with Outlet */}
        <Outlet />
      </div>
    </Content>
    {sidebar}
  </Layout>
)

export default AppContainer
